import { ReactNode, useEffect, useState } from "react"
import { Helmet } from "react-helmet"
import { matchPath, useLocation } from "react-router-dom"

import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"

import { Pages } from "@/pages/constants"
import { routes } from "@/pages/routes"

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`

type PageProps = {
  children: ReactNode
}

const PageTitles = {
  [Pages.ReceiptList]: "PORTAL_RECEIPTS_PAGE_TITLE",
  [Pages.ReceiptDetails]: "RECEIPTS_DETAILS_PAGE_TITLE",
  [Pages.ReceiptListV2]: "PORTAL_RECEIPTS_PAGE_TITLE",
  [Pages.ReceiptDetailsV2]: "RECEIPTS_DETAILS_PAGE_TITLE",
}

const TITLE_SEPARATOR = " | "

export const PageProvider = (props: PageProps) => {
  const { children } = props
  const [pageTitle, setPageTitle] = useState<string | undefined>()
  const location = useLocation()
  const { text } = useLocalization()

  useEffect(() => {
    const currentRoute = routes.find((route) =>
      matchPath(location.pathname, route as any),
    )

    const currentTitle = PageTitles[currentRoute?.path as Pages]

    let title = document.title.split(TITLE_SEPARATOR)[0]
    if (currentTitle) {
      title = title.concat(TITLE_SEPARATOR, text(currentTitle))
    }

    setPageTitle(title)
  }, [location, text])

  return (
    <Container>
      <div role="status" aria-live="assertive" aria-label={pageTitle} />
      <Helmet bodyAttributes={{ class: "theme-ppui" }}>
        <title>{pageTitle}</title>
      </Helmet>
      {children}
    </Container>
  )
}
